import angular from 'angular';
import validations from '../data/validations.json';

UpdatePayPacketController.$inject = [
  'ApplicationService',
  '$document',
  '$scope',
  '$rootScope',
  '$location',
  '$window'
];

function UpdatePayPacketController (ApplicationService, $document, $scope, $rootScope, $location, $window) {
  function init () {
    $document[0].title = 'Delta Dental - Update Broker Payment Information';
    $rootScope.previouslyAppointed = true;
    $scope.brokerInformation = {};
    $scope.validations = validations;
    $scope.submitForm = submitForm;
    $scope.currentSite = ApplicationService.getCurrentSite();
    $scope.contactEmail = 'DDMNBroker@DeltaDentalMN.org';
    if ($scope.currentSite === 'ne') {
      $scope.contactEmail = 'DDNEBroker@DeltaDentalNE.org';
    }
  }
  function submitForm (form) {
    var npnNumber = $scope.brokerInformation.npn;
    if (form.$valid) {
      $window.scrollTo(0, 0);
      $scope.error = false;
      $scope.loading = true;
      $scope.failure = false;
      var defaultBrokerInformation = ApplicationService.getBaseData().brokerInformation;
      var brokerInformation = angular.merge(defaultBrokerInformation, $scope.brokerInformation);
      var data = {
        'brokerInformation': brokerInformation,
        'previouslyAppointed': true
      };
      ApplicationService.setData(data, true);
      ApplicationService.npnInSalesforce(npnNumber).then(function (response) {
        $scope.loading = false;
        if (response && response.records) {
          var record = response.records[0];
          data.brokerInformation.firstName = record.FirstName;
          data.brokerInformation.middleName = record.Middle_name__c;
          data.brokerInformation.lastName = record.LastName;
          data.brokerExternalID = record.Broker_External_ID__c;
          ApplicationService.setData(data, true);
          $location.path('/application/update-pay-packet/information');
        } else {
          $scope.failure = true;
        }
      }, function () {
        $scope.loading = false;
        $scope.error = true;
        $window.scrollTo(0, 0);
      });
    }
  }
  init();
}

export default UpdatePayPacketController;



//////////////////
// WEBPACK FOOTER
// ./src/js/controllers/UpdatePayPacketController.js
// module id = 26
// module chunks = 0